import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AuthorizationDeliveryMode,
  ClientCodeRequest,
  Profile,
  ProspectCodeRequest,
  TokenResponse,
  UserLoginInfo,
  ValidateCodeRequest
} from '@shared/webapi/MIF.Subscription.WebApi';
import { RegistrationModel } from '@shared/extensions/user-data-extensions';
import { AdvertisementSourceDataModel } from '@signature/signature.extentions';
import {
  ClientAuthorizationStatus,
  ClientType,
  RequestCodeClientAuthError,
  ValidateCodeClientAuthError
} from './client.models';

export const clientActions = createActionGroup({
  source: 'Client Auth',
  events: {
    'Set Authorization Delivery Mode': props<{ authorizationDeliveryMode: AuthorizationDeliveryMode | null }>(),
    'Set Client Type': props<{ clientType: ClientType | null }>(),
    'Restore Client Type': props<{ clientType: ClientType }>(),
    'Set Pending Prospect Registration': props<{ registrationModel: RegistrationModel | null }>(),
    'Set Pending Prospect Advertisement Source': props<{
      advertisementSourceModel: AdvertisementSourceDataModel | null;
    }>(),
    'Clear Pending Prospect Data': emptyProps(),
    'Cancel Client Authentication': emptyProps(),
    'Submit Client Authentication': props<{ request: ClientCodeRequest }>(),
    'Submit Prospect Authentication': props<{ request: ProspectCodeRequest }>(),
    'Submit Client Authentication Success': props<{ authResponse: UserLoginInfo }>(),
    'Submit Client Authentication Failure': props<{ authError: RequestCodeClientAuthError }>(),
    'Validate Client Code': props<{ request: ValidateCodeRequest }>(),
    'Validate Client Code Success': props<{ tokenResponse: TokenResponse }>(),
    'Validate Client Code Failure': props<{ authError: ValidateCodeClientAuthError }>(),
    'Authorize Validated Client By User Id': props<{ userId: string }>(),
    'Authorize Validated Client': props<{ request: ClientCodeRequest }>(),
    'Authorize Validated Prospect Success': props<{ status: ClientAuthorizationStatus }>(),
    'Authorize Validated Client Success': props<{
      profile: Profile;
      status: ClientAuthorizationStatus;
    }>(),
    'Authorize Validated Client Failure': props<{ status: ClientAuthorizationStatus }>(),
    Reset: emptyProps()
  }
});